// @flow
import styled from 'styled-components';
import {
  textNormal,
  textBlack,
  textBold,
  textBoldLoose,
  textSemiBold,
} from './css';
import { Text1 } from './Text';

export const Text1Normal = styled(Text1)`
  ${textNormal};
`;

export const Text1Black = styled(Text1)`
  ${textBlack};
`;

export const Text1Bold = styled(Text1)`
  ${textBold};
`;

export const Text1SemiBold = styled(Text1)`
  ${textSemiBold};
`;

export const Text1BoldLoose = styled(Text1)`
  ${textBoldLoose};
`;
